import { useState } from 'react';
import { useDispatch, useReduxState } from 'hooks';
import api from 'api';
import { Alert, ConfirmButton } from 'components/common';
import { useEditorContext } from 'components/editor';
import { editorSocket } from 'components/editor/socket';

const AIGenerateChapterTitleTranslation = () => {
  const {
    editorAIEnabled,
    editorActiveLanguageVersion,
    editorCurrentChapter,
    editorChapterTitle: title,
    editorChapterTitleLocales: titleLocales
  } = useEditorContext();

  const { dispatch } = useDispatch();

  const {
    messages,
    pageState: { course }
  } = useReduxState();

  const [isLoading, setIsLoading] = useState(false);

  if (!editorAIEnabled) return null;

  const isEditingLanguageVersion =
    editorActiveLanguageVersion &&
    editorActiveLanguageVersion !== course.language;

  if (!isEditingLanguageVersion) return null;

  const handleConfirm = async () => {
    try {
      const chapterId = editorCurrentChapter.id;

      setIsLoading(true);

      const response = await api.post(
        `/admin/courses/${course.id}/language-versions/${editorActiveLanguageVersion}/ai-translations/generate`,
        { scope: 'chapterTitle', chapterId }
      );

      const translatedTitle =
        response.data?.translatedData?.[`chapter__${chapterId}__title`];

      if (translatedTitle) {
        editorSocket.updateTitle({
          chapterId,
          title,
          titleLocales: {
            ...titleLocales,
            [editorActiveLanguageVersion]: translatedTitle
          }
        });
      }

      return true;
    } catch (err) {
      await dispatch.handleErrorDispatch(err);
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  const confirmText = (
    <>
      <p style={{ margin: '0 0 12px' }}>
        {messages.aiGenerateTranslationsTranslateTitleConfirm}
      </p>
      <Alert
        size="small"
        text={messages.aiGenerateTranslationsTranslateTitleOverwrite}
        type="warning-light"
      />
    </>
  );

  return (
    <ConfirmButton
      actionText={messages.commonTranslate}
      buttonCategory="light"
      buttonIcon="wand-magic-sparkles"
      buttonSize="small"
      buttonText={messages.commonTranslate}
      confirmText={confirmText}
      confirmTitle={messages.aiGenerateTranslationsTranslateWithAi}
      disabled={isLoading}
      onConfirm={handleConfirm}
    />
  );
};

export default AIGenerateChapterTitleTranslation;
